import { IconSvg } from './IconSvg'
import type { IconProps } from './IconSvg'

/** waste bin, delete. Decorative line icon; always pair with a visible text label. */
export function TrashIcon({ size, className }: IconProps) {
  return (
    <IconSvg size={size} className={className}>
      <path d="M3.5 6h17" />
      <path d="M8.5 6V4a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v2" />
      <path d="M19 6l-1 14a2 2 0 0 1-2 1.8H8A2 2 0 0 1 6 20L5 6" />
      <path d="M10 11v6" />
      <path d="M14 11v6" />
    </IconSvg>
  )
}
